module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [(_vm.isDianDianHome) ? _c('div', {
    staticClass: "fi-pc"
  }, [_c('div', {
    staticClass: "fi-main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "banner-container"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, _vm._l((_vm.page), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dh-page"
    }, [_c('span', {
      staticClass: "m-page"
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "nav-container"
  }, [_c('ul', _vm._l((_vm.navText), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': _vm.navActive[index]
      },
      on: {
        "click": function($event) {
          return _vm.paginationHandle(index)
        }
      }
    }, [_c('i'), _vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "home-user"
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "fi-footer"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "footer-text",
    domProps: {
      "innerHTML": _vm._s('Copyright © 169 2017 - 2018 Diandiango 点点GO版权所有 粤ICP备17079095号-2')
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isBepoint) ? _c('div', [_c('iframe', {
    staticClass: "fdyx",
    attrs: {
      "src": "https://one.zhongan.com/fcp/fdyx/index.htm"
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fi-header"
  }, [_c('h2', {
    staticClass: "dd-go"
  }, [_vm._v("点点GO")]), _vm._v(" "), _c('div', {
    staticClass: "hr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-left"
  }, [_c('ul', [_c('li', [_c('div', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("点点商城")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('strong', [_vm._v("潮流好物,应有尽有")]), _vm._v(" "), _c('p', [_vm._v("点一点，汇集时尚潮物，甄选全网低价尖货。 众安保险保障账户安全，为购物保驾护航。")])]), _vm._v(" "), _c('li', [_c('div', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("生活缴费")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('strong', [_vm._v("足不出户,生活助手")]), _vm._v(" "), _c('p', [_vm._v("点一点，所有水、电、煤等生活缴费， 在手机上即可完成。 生活已然艰辛，点点为您省心。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-right"
  }, [_c('ul', [_c('li'), _vm._v(" "), _c('li')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diandian-pro"
  }, [_c('ul', [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ea5ceee"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DdGo.vue
// module id = 383
// module chunks = 1